import { AppItem } from "@app/types";

export function sleep(n: number) {
  return new Promise((resolve) => setTimeout(resolve, n));
}

export function inRange(min: number, max: number, n: number) {
  return n >= min && n <= max;
}

export function contains(needle: string, haystack: string) {
  return haystack.indexOf(needle) > -1;
}

export function containsInsensitive(needle: string, haystack: string) {
  return haystack.toLocaleLowerCase().indexOf(needle.toLocaleLowerCase()) > -1;
}

export function containsEvery(str: string, args: string[]) {
  let needles = args.slice(0, args.length - 1).filter((x) => !!x);
  for (let needle of needles) {
    if (str.indexOf(needle) === -1) return false;
  }
  return true;
}

export function containsAny(str: string, args: string[]) {
  let needles = args.slice(0, args.length - 1).filter((x) => !!x);
  for (let needle of needles) {
    if (str.indexOf(needle) > -1) return true;
  }
  return false;
}

export function randomInRange(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function randomFromArray<T>(arr: T[]): T | undefined {
  return arr[randomInRange(0, arr.length - 1)];
}

export function waitUntil<R>(fn: () => R) {
  const r = fn();
  if (r) {
    return Promise.resolve<R>(r);
  }
  return new Promise<R>((resolve) => {
    const interval = setInterval(() => {
      const r = fn();
      if (r) {
        resolve(r);
        clearInterval(interval);
      }
    }, 20);
  });
}

export function cloneItem(item: AppItem) {
  const out: AppItem = {
    id: item.id,
    name: item.name,
    tags: item.tags.slice(0),
    addedAt: item.addedAt,
    rating: item.rating,
    link: item.link,
  };
  return out;
}

export function normalizeLink(link: string) {
  const a = document.createElement("a");
  a.href = link;
  return a.href;
}

export function crealeCssLink(link: string) {
  const el = document.createElement("link");
  el.rel = "stylesheet";
  el.href = link;
  return el;
}

export function loadCss(link: string) {
  const el = crealeCssLink(link);
  const links = document.head.querySelectorAll("link");
  for (let l of links) {
    if (l.href === el.href) {
      return;
    }
  }
  document.head.appendChild(el);
}

export function toTitleCase(text: string) {
  return text.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1);
  });
}

export class SRandom {
  _initialSeed: number;
  _seed: number;
  constructor(seed: number) {
    this._initialSeed = seed;
    this._seed = seed % 2147483647;
    if (this._seed <= 0) this._seed += 2147483646;
  }
  reset() {
    this._seed = this._initialSeed;
  }
  next(minOrMax: number, max: number) {
    this._seed = (this._seed * 16807) % 2147483647;
    switch (arguments.length) {
      case 0:
        return this._seed / 2147483647;
      case 1:
        return (this._seed / 2147483647) * minOrMax;
    }
    return (this._seed / 2147483647) * (max - minOrMax) + minOrMax;
  }
  nextInt(minOrMax: number, max: number) {
    return Math.round(this.next(minOrMax, max));
  }
  fromArray<T>(arr: T[]): T | undefined {
    return arr[this.nextInt(0, arr.length - 1)];
  }
}
